import React from 'react';

export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height="15"
    width="20"
    aria-hidden="true"
    focusable="false"
    viewBox="0 0 24 24"
    style={{ verticalAlign: 'middle' }}
  >
    <path
      d="M22 12a10 10 0 0 1-10 10 10 10 0 0 1-7.071-2.929 10 10 0 0 1 0-14.142 10 10 0 0 1 10.898-2.168 10 10 0 0 1 5.412 5.412A10 10 0 0 1 22 12zm-12 6l6-6-6-6-1.4 1.4 4.6 4.6-4.6 4.6L10 18z"
      fill="#06c"
    />
  </svg>
);
